import React, { useEffect, useState } from 'react'
import Header from 'components/Header'
import { Col, Row } from 'react-bootstrap'
import { useRecoilState } from 'recoil'
import { reqGetAllProducts } from 'product/ProductRequests'
import { productsRecoilState } from 'product/ProductsState'
import ProductListForSelect from 'product/product_list/product_list_for_select/ProductListForSelect'
import CartTotalPanel from './CartTotalPanel'
import MySpinner from 'components/MySpinner'

const ProductsPage: React.FC = () => {
  const [products, setProducts] = useRecoilState(productsRecoilState)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let mount = true

    if (products === null) {
      setIsLoading(true)
      reqGetAllProducts((products) => {
        setIsLoading(false)
        if (mount) {
          setProducts(products)
        }
      })
    }

    return () => {
      mount = false
    }
  }, [products, setProducts])

  return (
    <>
      <Row>
        <Col xs={12} className='pt-header'>
          <Header>Доступные товары</Header>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={8} className='gx-0'>
          {isLoading || !products ? (
            <MySpinner />
          ) : products.length === 0 ? (
            <h4>В магазине временно отсутствуют товары</h4>
          ) : (
            <ProductListForSelect products={products} />
          )}
        </Col>
        <Col xs={12} lg={4}>
          <CartTotalPanel />
        </Col>
      </Row>
    </>
  )
}
export default ProductsPage
